import React from "react";
import * as styles from "./styles.module.scss";
import hamburgerIcon from "./hamburger.svg";
import Link from "../Link";
import useLogin from "../../effects/useLogin";
import cx from "classname";

function SiteNavigation({ links, logIn, joinNow }) {
  const login = useLogin();

  const openMenu = () => {
    window.dispatchEvent(new CustomEvent("toggleMobileMenu"));
  };

  return (
    <div className={styles.header}>
      <header className={styles.headerBar}>
        <div className={styles.left}>
          <div className={styles.logo}>
            <Link url="/">
              <img
                src="/img/logo-dark.svg"
                alt="Cove Logo"
                width="98"
                height="22"
              />
            </Link>
          </div>

          <ul className={styles.desktopNav}>
            {links.map((link, i) => {
              return (
                <li key={i}>
                  <Link className={styles.desktopNavLink} {...link} />
                </li>
              );
            })}
          </ul>
        </div>

        <div className={styles.right}>
          <button
            onClick={login}
            className={cx(styles.loginButton, "linkUnderline")}
          >
            {logIn.label}
          </button>

          <Link
            url={joinNow.url}
            id="joinow-cta"
            className={cx(styles.purchaseCta, "button blue small")}
          >
            About Cove
          </Link>

          <button
            className={cx(styles.transparentBtn, styles.mobileToggle)}
            onClick={openMenu}
          >
            <img src={hamburgerIcon} alt="Menu" width="28" height="20" />
          </button>
        </div>
      </header>
    </div>
  );
}

SiteNavigation.defaultProps = {
  enableCTA: true,
  logIn: {
    label: "",
    url: ""
  }
};

export default SiteNavigation;
